module.exports = __webpack_public_path__ + "static/media/elephant.bf4eefff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/elephant.svg
// module id = 129
// module chunks = 0